/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class t{constructor(){this.factor=new c,this.factorAlignment=new c}}class c{constructor(){this.scale=0,this.factor=0,this.minScaleFactor=0}}export{c as ScaleFactor,t as ScaleInfo};
